import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from '../../services/tenant/tenant.service';
import { AppStorage } from '../../enums/app-storage';

export const tenantGuard: CanActivateFn = route => {
  const router = inject(Router);
  const tenantService = inject(TenantService);

  const storedTenant = localStorage.getItem(AppStorage.tenant) || 'dib';
  const tenant = route.paramMap.get('tenant') || storedTenant;

  // Basic Format Validation
  if (!tenant || !/^[a-z0-9-]+$/.test(tenant)) {
    return router.createUrlTree(['/' + tenant]);
  }

  tenantService.setTenant(tenant);
  return true;
};
